import axios from "axios";
import { NotProcessingService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotProcessingResponseDTO } from "./dto";
import { downloadFileFromResponse } from "../../../../../utils/download";

export class NotProcessingImpl implements NotProcessingService {

    public GetAllNotProcessing(filters: filtersDTO): Promise<NotProcessingResponseDTO> {
        return axios.get("/api/notification-processing", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public IdentificationBoardProcessingNotification(notId: string): Promise<any> {
        return axios.get("/api/download/identification-board-processing-pdf/"+notId, {
            params: {
                notId: notId,
                
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => {
            downloadFileFromResponse(response.data, 'scheda_identificativa_preparazione.pdf', 'application/pdf');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

}